<template>
  <ApolloQuery ref="theQuery" v-bind="$attrs" fetch-policy="no-cache" notifyOnNetworkStatusChange tag="span">
    <template v-slot="{ result: { loading, error, data } }">
      <slot name="loading" v-if="loading">
        <ProgressSpinner style="width:28px;height:28px" strokeWidth="4" />
      </slot>
      <slot name="error" v-else-if="error">
        <Message severity="error" :closable="false">
          {{ friendlyError(error) }}
          <Button
            label="Retry"
            icon="pi pi-refresh"
            class="p-button-text p-button-sm tw-ml-2"
            @click="refresh"
          />
        </Message>
      </slot>
      <slot v-else-if="data" v-bind="{ data, refresh }" />
    </template>
  </ApolloQuery>
</template>

<script>
export default {
  methods: {
    friendlyError(error) {
      const msg = (error && error.message) || 'An error occurred'
      if (/load failed|failed to fetch|network error|econnrefused/i.test(msg)) {
        return 'API offline — leave npm run dev running (auto-restarts). Retry in a moment.'
      }
      return msg
    },
    refresh() {
      this.$refs.theQuery.$_apollo.queries.query.refetch()
    },
  },
}
</script>
